import { Component } from '@angular/core';
import { searchGameTrx } from 'src/app/router-translation.labels';
import { CategoryPageComponent } from '../../games/category-page/category-page.component';

@Component({
  selector: 'app-desktop-category-page',
  templateUrl: './desktop-category-page.component.html',
  styleUrls: ['./desktop-category-page.component.scss']
})
export class DesktopCategoryPageComponent extends CategoryPageComponent {
  search = searchGameTrx
  ngOnInit(): void {
    this.getData();
  }

  searchInput(data) {
    this.router.navigate(['/', this.search, { query: data }]);
  }
}
